module.exports = "<div [hidden]=\"!data.status\" mat-dialog-content>\n    \n</div>\n\n\n\n\n\n\n\n\n"